import { createSlice } from '@reduxjs/toolkit'
import incomeApi from 'src/api/income'
import courseApi from 'src/api/course'

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,
  detail: null,
  courseDetail: null,
  startDate: '',
  endDate: '',
  employeeList:null,
  groupList:null,
  details: {
    id: null,
    total: 0,
    courseProducts: [],
    paid: 0,
    paymentHistories: [],
  },
  productsDto:null
}

const slice = createSlice({
  name: 'income_detail',
  initialState,
  reducers: {
    setCourseDetail(oldState, action) {
      oldState.courseDetail = action.payload
    },
    setIncomeDetail(oldState, action) {
      oldState.detail = action.payload
    },
    setIncomeSearchDate(oldState, action) {
      oldState.startDate = action.payload.startDate
      oldState.endDate = action.payload.endDate
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
    openModal(oldState) {
      oldState.isModalOpen = true
    },
    addOrderProduct(oldState, action) {
      const newProduct = action.payload
      oldState.productsDto = [...oldState.productsDto,newProduct]
    },
    deleteOrderProduct(oldState, action) {
      const courseProduct = action.payload
      let courseProducts = [...oldState.details.courseProducts]
      const idx = courseProducts.findIndex((cp) => cp.id === courseProduct.id)

      courseProducts = courseProducts
        .slice(0, idx)
        .concat(courseProducts.slice(idx + 1, courseProducts.length))

      const total =
        courseProducts && courseProducts.length > 0
          ? courseProducts.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

      oldState.details = {
        ...oldState.details,
        total: total,
        courseProducts: courseProducts,
      }
    },
    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },
    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },
    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
  },
})

export const reducer = slice.reducer

// export const setIncomeDetail = (query) => async (dispatch) => {
//   const detail = await incomeApi.searchSalesProfit(query)
//   dispatch(slice.actions.setIncomeDetail(detail))
// }
export const getCourseDetailById = (id) => async (dispatch) => {
  const detail = await courseApi.findCourseById(id)
  dispatch(slice.actions.setCourseDetail(detail))
}

export const setCourseDetail = (detail) => (dispatch) => {
  dispatch(slice.actions.setCourseDetail(detail))
}

export const editCoursePayment = (courseId, id, paymentDto) => async (
  dispatch
) => {
  const detail = await courseApi.editCoursePayment(courseId, id, paymentDto)
  dispatch(slice.actions.setCourseDetail(detail))
}

export const setIncomeSearchDate = (date) => async (dispatch) => {
  dispatch(slice.actions.setIncomeSearchDate(date))
}
export const addOrderProduct = (courseProduct) => async (dispatch) => {
  dispatch(slice.actions.addOrderProduct(courseProduct))
}


export const deleteOrderProduct = (courseProduct) => async (dispatch) => {
  dispatch(slice.actions.deleteOrderProduct(courseProduct))
}

//number id
//boolean lockStatus
export const editIncomeLocked = (id, status) => async (dispatch) => {
  const detail = await incomeApi.patchSalesProfitLocked(id, status)
  
  dispatch(slice.actions.setIncomeDetail(detail))
}

export const editIncomeSales = (cashInId,orderNumber,salesId) => async (dispatch) => {
  const detail = await incomeApi.updateCourseSalesByCourseId(cashInId,orderNumber,salesId)
  
  dispatch(slice.actions.setIncomeDetail(detail))
}

// Reload
export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export default slice
